import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { appState } from "$store";

import { useUsersQuery } from "$hooks/useUsersQuery";
import useUserForm from "$hooks/useUserForm";

export const useProjectFormLogic = (project?: any, defaultValuesForm?: any) => {
  const [isAlias, setIsAlias] = useState(false);

  const { data: contacts = [] } = useUsersQuery();
  const { filter: companySidebarFilter } = useSelector(appState);

  const defaultValues = project
    ? {
        ...project,
        name: project.name,
        code: project.code,
        description: project.description,
        company: project.company?._id,
        contact: project.contact?._id,
        email: project.contact?.email,
        phone: project.contact?.phone,
      }
    : {
        id: null,
        company: defaultValuesForm?.company || companySidebarFilter?._id,
        name: null,
        code: null,
        description: null,
        contact: null,
        email: null,
        phone: null,
      };

  const form = useForm({
    mode: "onChange",
    defaultValues,
  });

  const currentCompany = form.watch("company", defaultValues.company);
  const currentContact = form.watch("contact", defaultValues.contact);

  const currentContactObject = contacts?.find(
    (c: any) => c._id === currentContact
  );

  const {
    onAddClick,
    onSubmit: onUserSubmit,
    onSubmitEdit: onUserSubmitEdit,
    setTitle,
    open: openUser,
    togglePopin: toggleUserPopin,
    error: errorUser,
  } = useUserForm(currentCompany);

  const handleUserAddClick = () => {
    onAddClick();
    form.setValue("contact", undefined);
    setTitle("Ajouter un contact");
  };

  const handleUserPopinSubmit = async (data: any) => {
    if (currentContact) {
      await onUserSubmitEdit(data);
      form.setValue("email", data.email);
      form.setValue("phone", data.phone);
    } else {
      const newUser = await onUserSubmit(data);

      form.setValue("contact", newUser._id);
      form.setValue("email", data.email);
      form.setValue("phone", data.phone);
    }
  };

  useEffect(() => {
    const regex = /\+\d{13}@/;
    const test = regex.test(currentContactObject?.email || "");
    setIsAlias(test);
  }, [currentContactObject]);

  return {
    form,
    isAlias,
    currentCompany,
    currentContact,
    currentContactObject,
    handleUserAddClick,
    handleUserPopinSubmit,

    // user form
    onAddClick,
    openUser,
    toggleUserPopin,
    onUserSubmit,
    onUserSubmitEdit,
    errorUser,
    setTitle,
  };
};
